import { PropsWithChildren } from "react";
import { styled } from "styled-components";
import { mobileBreakPointCSS } from "../defaults/theme.js";

interface Props {
  onClose: () => void;
}

export const Modal: React.FC<PropsWithChildren<Props>> = ({
  onClose,
  children,
}) => {
  return (
    <div onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        {children}
      </ModalContent>
    </div>
  );
};

const ModalContent = styled.div`
  width: 100%;
  max-width: 90%;
  position: relative;
  margin: auto;
  z-index: 99;

  @media (min-width: ${mobileBreakPointCSS}) {
    max-width: 800px;
  }
`;
